import { useEffect } from 'react';
import { useAnalytics } from '@medely/ui-kit/web';
import { useCurrentUserStorage } from 'providers/authProvider';

/**
 * Logs the current admin into Intercom through Segment (secure mode), mirroring
 * the facility/pro clients. This is what establishes the authenticated Intercom
 * session so admins can browse published help center articles.
 */
export const useIntercomIdentify = (): void => {
  const analytics = useAnalytics();
  const { currentUser } = useCurrentUserStorage();

  useEffect(() => {
    // Wait for user_hash so Intercom secure mode (identity verification) works.
    // Without it the identify reaches Intercom but cannot establish a trusted
    // session, so help center articles stay gated.
    if (!currentUser?.id || !currentUser?.user_hash) {
      return;
    }

    analytics.identify(
      currentUser.id.toString(),
      {
        name: currentUser.name,
        email: currentUser.email,
        hide_default_launcher: true,
        administrator: true,
      },
      {
        Intercom: { user_hash: currentUser.user_hash },
      },
    );
  }, [currentUser?.id, currentUser?.user_hash]);
};
